export default {
    IntervalDay: 'IntervalDay',
    IntervalDayMin: 'IntervalDay min',
    IntervalDayMax: 'IntervalDay max',
    MaximumOrderQuantity: 'Maximum Order Quantity',
    MaximumOrderQuantityMin: 'Maximum Order Quantity min',
    MaximumOrderQuantityMax: 'Maximum Order Quantity max',
    MinimumOrderQuantity: 'minimum Order Quantity',
    MinimumOrderQuantityMin: 'minimum Order Quantity min',
    MinimumOrderQuantityMax: 'minimum Order Quantity max',
    Slug: 'slug',
    SortOrder: 'SortOrder',
    Title: 'title'
}